// Lightweight rational number for Faraid share arithmetic.
// Numerators/denominators stay small (LCM rarely > a few hundred), so
// regular JS numbers are fine.

function gcd(a: number, b: number): number {
  a = Math.abs(a); b = Math.abs(b);
  while (b) { [a, b] = [b, a % b]; }
  return a || 1;
}

export class F {
  readonly n: number;
  readonly d: number;
  constructor(n: number, d: number = 1) {
    if (d === 0) throw new Error("Fraction denominator cannot be zero");
    if (d < 0) { n = -n; d = -d; }
    const g = gcd(n, d);
    this.n = n / g;
    this.d = d / g;
  }
  static zero = new F(0, 1);
  static one = new F(1, 1);
  add(o: F): F { return new F(this.n * o.d + o.n * this.d, this.d * o.d); }
  sub(o: F): F { return new F(this.n * o.d - o.n * this.d, this.d * o.d); }
  mul(o: F): F { return new F(this.n * o.n, this.d * o.d); }
  div(o: F): F { return new F(this.n * o.d, this.d * o.n); }
  scale(k: number): F { return new F(this.n * k, this.d); }
  toNumber(): number { return this.n / this.d; }
  cmp(o: F): number { return this.n * o.d - o.n * this.d; }
  eq(o: F): boolean { return this.cmp(o) === 0; }
  isZero(): boolean { return this.n === 0; }
  isPositive(): boolean { return this.n > 0; }
  toString(): string { return this.d === 1 ? `${this.n}` : `${this.n}/${this.d}`; }
}

export function sumF(arr: F[]): F {
  return arr.reduce((acc, f) => acc.add(f), F.zero);
}
